module.exports = __webpack_public_path__ + "static/media/05_1.e23fffbb.mp3";